import styled from 'styled-components'

export const AddMemberWrapper = styled.div`
  margin-bottom: 20px;
`

export const MemberButtonWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-end;
  
  .member-input {
    flex: 1;
  }
  
  .add-button {
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    
    .add-button {
      margin-top: 8px;
    }
  }
`

export const LimitMessage = styled.div`
  background: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  color: #1976d2;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`